import React from "react";
import { Pressable, Text, StyleSheet } from "react-native";
import { NormalText } from ".";
import Icon from "react-native-vector-icons/Feather"; // or MaterialIcons, etc.

type SortHeaderProps = {
  label: string;
  field: string;
  sortConfig: {
    field: string;
    order: "asc" | "desc";
  };
  onSortChange: (field: string, order: "asc" | "desc") => void;
};

const SortHeader: React.FC<SortHeaderProps> = ({
  label,
  field,
  sortConfig,
  onSortChange,
}) => {
  const isActive = sortConfig.field === field;
  const isAsc = sortConfig.order === "asc";

  const toggleSort = () => {
    const newOrder = isActive && isAsc ? "desc" : "asc";
    onSortChange(field, newOrder);
  };

  return (
    <Pressable onPress={toggleSort} style={styles.headerButton}>
      <NormalText text={label} fontWeight="600" />
      {isActive && (
        <Icon
          name={isAsc ? "chevron-up" : "chevron-down"}
          size={14}
          color="#444"
        />
      )}
    </Pressable>
  );
};

const styles = StyleSheet.create({
  headerButton: {
    flexDirection: "row",
    alignItems: "center",
    gap: 4,
  },
  sortIcon: {
    fontSize: 12,
    color: "#444",
  },
});

export default SortHeader;
